import React, { useEffect, useState } from 'react';
import { accessService } from '../../../services/central-api/access';
import FilterBadgeSearchList, { FilterListItem } from './FilterBadgeSearchList';

type Props = {
    actingBodyId?: number | null;
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
};

function ActingBodyUnitsList({ value, setValue, actingBodyId }: Props) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getActingBodyUnits(actingBodyId: number) {
        try {
            setIsLoading(true);
            const actingBody = await accessService.getActingBody(actingBodyId);
            if (!actingBody.actingBodyUnits) {
                setItems([]);
            } else {
                setItems(actingBody.actingBodyUnits.map((unit) => ({
                    value: unit.id || 0,
                    label: unit.name,
                })));
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (actingBodyId && actingBodyId > 0) {
            getActingBodyUnits(actingBodyId);
        } else {
            setItems([]);
            setIsLoading(false);
        }
    }, [actingBodyId]);

    return <FilterBadgeSearchList items={items} value={value} setValue={setValue} isLoading={isLoading} />;
}

export default ActingBodyUnitsList;
